import cn from "classnames";
import React, { useState } from "react";
import { ProgressBar } from ".";

export default (props) => {
    return (
        <div className="card mb-3">
            <div className="card-header">
                Максимальный размер запросов/ответов. Запрос - <b>{props.requestsSize.maxRequestLength}</b>; Ответ
                -&nbsp;
                <b>{props.requestsSize.maxResponseLength}</b>; Общий размер - <b>{props.requestsSize.totalLength}</b>
            </div>
            <div className="card-body">
                {props.requestsSize.topUsers.map((userData) => (
                    <UserRequestsSizeData
                        key={userData.user}
                        {...userData}
                        overallMaxRequestLength={props.requestsSize.maxRequestLength}
                        overallMaxResponseLength={props.requestsSize.maxResponseLength}
                        overallTotalLength={props.requestsSize.totalLength}
                    />
                ))}
            </div>
        </div>
    );
};

const UserRequestsSizeData = (props) => {
    const [opened, setOpened] = useState(false);
    return (
        <div key={props.user} className="mb-2">
            <div className="row">
                <div className="col-sm-3 ellipsis">
                    <div
                        className={cn("d-inline-block collapse-btn", {
                            "collapse-btn--down": !opened,
                            "collapse-btn--up": opened,
                        })}
                        onClick={() => setOpened(!opened)}
                    />
                    <span title={props.user}>{props.user}</span>
                </div>
                <div className="col-sm-9 d-flex align-items-center">
                    <ProgressBar
                        title="Запрос:"
                        maxCount={props.overallMaxRequestLength}
                        count={props.maxRequestLength}
                    />
                </div>
                <div className="offset-sm-3 col-sm-9 d-flex align-items-center mb-2">
                    <ProgressBar
                        title="Ответ:"
                        maxCount={props.overallMaxResponseLength}
                        count={props.maxResponseLength}
                    />
                </div>
                <div className="offset-sm-3 col-sm-9 d-flex align-items-center mb-2">
                    <ProgressBar title="Общий размер:" maxCount={props.overallTotalLength} count={props.totalLength} />
                </div>
            </div>
            {opened && (
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <td className="text-muted small">Запрос</td>
                            <td className="text-muted small">Макс. размер запроса</td>
                            <td className="text-muted small">Макс. размер ответа</td>
                            <td className="text-muted small">Общий размер</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.topRequests.map((item) => (
                            <tr key={item.path}>
                                <td>{item.path}</td>
                                <td>{item.maxRequestLength}</td>
                                <td>{item.maxResponseLength}</td>
                                <td>{item.totalLength}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};
